export const PACE_COLORS = {
    ahead: 'var(--color-success)',
    behind: 'var(--color-danger)',
    on_track: 'var(--color-text)',
};

export const FACTION_COLORS = {
    0: 'var(--color-faction-bugs)',
    1: 'var(--color-faction-cyborgs)',
    2: 'var(--color-faction-illuminate)',
};
